import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import styles from "../styles/StepTwo.module.css";

const ReturnModal = ({
    formValues,
    setFormValues,
    vehicle,
    handleRoundWayTrip,
}) => {
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);
    const [errors, setErrors] = useState({});

    const validateReturnForm = () => {
        let errors = {};

        if (!formValues.returnDate) {
            errors.returnDateError = "Enter a return pick up date.";
        }

        if (!formValues.returnTime) {
            errors.returnTimeError = "Enter a return pick up time.";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleReturnFormSubmit = (vehicle) => {
        const result = validateReturnForm();
        if (result === true) {
            toggle();
            handleRoundWayTrip(vehicle);
        }
    };
    return (
        <div>
            <button className={styles.selectCarBtn} onClick={toggle}>
                Return Journey
            </button>
            <Modal isOpen={modal} toggle={toggle} backdrop="static">
                <ModalHeader toggle={toggle}>
                    Retrun Journey Details
                </ModalHeader>
                <ModalBody>
                    <div className="col mt-3">
                        <label className={styles.formLabel}>
                            Enter Return Date{" "}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <DatePicker
                            className={`${styles.formInput1}`}
                            selected={formValues.returnCalDate}
                            onChange={(date) => {
                                if (
                                    errors.hasOwnProperty(["returnDateError"])
                                ) {
                                    delete errors[["returnDateError"]];
                                }
                                setFormValues({
                                    ...formValues,
                                    returnCalDate: date,
                                    returnDate: date.toDateString(),
                                });
                            }}
                            minDate={new Date()}
                            locale="en"
                            showDateSelect
                            dateFormat="MM/dd/yyyy"
                            closeOnScroll={(e) => e.target === document}
                            required
                        />
                        {errors.returnDateError && (
                            <span style={{ color: "red" }}>
                                {errors.returnDateError}
                            </span>
                        )}
                        <br />
                        <label className={styles.formLabel}>
                            Enter Return Time{" "}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <DatePicker
                            className={styles.formInput1}
                            selected={formValues.returnCalTime}
                            onChange={(date) => {
                                if (
                                    errors.hasOwnProperty(["returnTimeError"])
                                ) {
                                    delete errors[["returnTimeError"]];
                                }
                                setFormValues({
                                    ...formValues,
                                    returnCalTime: date,
                                    returnTime: date.toLocaleTimeString(),
                                });
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                        />
                        {errors.returnTimeError && (
                            <span style={{ color: "red" }}>
                                {errors.returnTimeError}
                            </span>
                        )}
                        <br />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        style={{
                            background: "#ececec",
                            color: "#000000",
                            border: "none",
                        }}
                        onClick={toggle}
                    >
                        Cancel
                    </Button>{" "}
                    <Button
                        color="secondary"
                        style={{
                            background: "#b68b47",
                            color: "#ffffff",
                            border: "none",
                        }}
                        onClick={() => handleReturnFormSubmit(vehicle)}
                    >
                        Confirm
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ReturnModal;
